import { createContext, useState } from 'react';

interface CompanyContext {
  companyId?: string;
  setCompanyId: (companyId?: string) => void;
}

export const CompanyContext = createContext<CompanyContext>({} as CompanyContext);

export const CompanyContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [companyId, setCompanyId] = useState<string | undefined>(undefined);

  return (
    <CompanyContext.Provider value={{ companyId, setCompanyId }}>
      {children}
    </CompanyContext.Provider>
  );
};
